'use client'

import { html } from '@ensemble.music/ui'
import { CONTACT_EMAIL, REGION } from './content'
import { MastodonIcon } from './MastodonIcon'

export function FooterLandingPage() {
  return (
    <html.footer className="w-full bg-background-subtle border-t border-border-color">
      <html.div className="flex flex-row flex-wrap items-center justify-between gap-6 w-full max-w-[1120px] mx-auto px-8 py-8 max-sm:px-4 max-sm:flex-col max-sm:items-start">
        <html.a
          href="/"
          aria-label="ensemble, zur Startseite"
        >
          <html.img
            src="/images/Logo_3.svg"
            alt="ensemble"
            width={88}
            height={62}
          />
        </html.a>

        <html.nav
          className="flex flex-col gap-1"
          aria-label="Rechtliches"
        >
          <html.a
            href="/fuer-ensembles"
            className="text-sm text-link hover:underline"
          >
            Für Ensembles
          </html.a>
          <html.a
            href="/agb"
            className="text-sm text-link hover:underline"
          >
            Allgemeine Geschäftsbedingungen
          </html.a>
          <html.a
            href="/impressum"
            className="text-sm text-link hover:underline"
          >
            Impressum
          </html.a>
          <html.a
            href="/datenschutz"
            className="text-sm text-link hover:underline"
          >
            Datenschutz
          </html.a>
          <html.a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-sm text-link hover:underline"
          >
            Kontakt
          </html.a>
        </html.nav>

        <html.p className="text-sm text-color-tertiary max-w-[220px]">Aktuell in {REGION}.</html.p>

        <html.div className="flex flex-row items-center gap-4">
          <html.a
            href="https://mastodon.art/@stefaneissler"
            target="_blank"
            rel="noreferrer"
            aria-label="ensemble auf Mastodon"
            className="text-link"
          >
            <MastodonIcon />
          </html.a>
          <html.a
            href="https://www.facebook.com/profile.php?id=61575267894817"
            target="_blank"
            rel="noreferrer"
            className="text-sm text-link hover:underline"
          >
            Facebook
          </html.a>
        </html.div>
      </html.div>
    </html.footer>
  )
}
